import { render, staticRenderFns } from "./BasicData.vue?vue&type=template&id=55b1490e&scoped=true"
import script from "./BasicData.vue?vue&type=script&lang=js"
export * from "./BasicData.vue?vue&type=script&lang=js"
import style0 from "./BasicData.vue?vue&type=style&index=0&id=55b1490e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1490e",
  null
  
)

export default component.exports